var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SchemaModule, ModuleValue } from './module';
import { DATE_DAY } from '../constants';
var ModuleValueUniversal = (function (_super) {
    __extends(ModuleValueUniversal, _super);
    function ModuleValueUniversal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueUniversal;
}(ModuleValue));
export { ModuleValueUniversal };
var SchemaModuleUniversal = (function (_super) {
    __extends(SchemaModuleUniversal, _super);
    function SchemaModuleUniversal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SchemaModuleUniversal.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
    };
    SchemaModuleUniversal.prototype.fieldHandlerDischargeDate = function (lengthOfStayProperty) {
        var _this = this;
        return function (dischargeDateString, dateOfSurgeryString) {
            var dateOfSurgery = new Date(dateOfSurgeryString);
            var dischargeDate = new Date(dischargeDateString);
            var lengthOfStay = Math.ceil((dischargeDate.valueOf() - dateOfSurgery.valueOf()) / DATE_DAY);
            if (isNaN(lengthOfStay.valueOf()) || lengthOfStay < 0) {
                lengthOfStay = null;
            }
            _this.updateValue(lengthOfStayProperty, lengthOfStay);
        };
    };
    return SchemaModuleUniversal;
}(SchemaModule));
export { SchemaModuleUniversal };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-universal.ts.pre-build-optimizer.js